import { render, staticRenderFns } from "./LayoutCustomer.vue?vue&type=template&id=16d3e297"
import script from "./LayoutCustomer.vue?vue&type=script&lang=js"
export * from "./LayoutCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports